
export const moduleId = "app";

export const state = {
  fullHeight: null, // 窗口高度
  fullWidth: null, // 窗口宽度
  activeMenu:null,//侧边栏



};

export const actions = {};

export const mutations = {
  // 设置窗口数据
  setWindowData(state, {fullHeight, fullWidth}) {
    state.fullHeight = fullHeight;
    state.fullWidth = fullWidth;
  },
  setActiveMenu(state,data){
    state.activeMenu= data

  }


};




// WEBPACK FOOTER //
// ./src/store/modules/app/index.js